<template>
  <v-container fluid>
    <material-card
      :heading="heading"
      icon-small
      icon="mdi-clipboard-list-outline"
      :title="heading"
      color="primary"
    >
      <v-card-text>
        <!-- pc view -->
        <v-data-table
          v-if="$vuetify.breakpoint.mdAndUp"
          :headers="getHeaders()"
          :items="meetings"
          :loading="loading"
          :options="options"
          loading-text="Loading... Please wait"
        >
          <!-- <template
            slot="items"
            slot-scope="props"
          >
            <td>
              {{ props.item.startDtime }}
            </td>
            <td>
              {{ props.item.endDtime }}
            </td>
            <td>
              <v-icon
                small
                :color="'green'"
              >
                mdi-door-open
              </v-icon>
              {{ props.item.roomIds.length > 0 ? props.item.roomIds[0].typeName : '-' }}
            </td>
            <td>
              {{ props.item.roomIds.length > 1 ? `${props.item.roomIds[0].name} +${props.item.roomIds.length - 1} others`
                : props.item.roomIds.length > 0 ? props.item.roomIds[0].name : '' }}
            </td>
            <td>
              {{ props.item.creator.displayFullName ? props.item.creator.displayFullName : props.item.creator.username }}
            </td>
            <td>
              {{ props.item.title }}
            </td>
            <td class="text-center">
              <v-icon
                v-if="props.item.repeatInfo.freq !== null && props.item.repeatInfo.freq !== undefined"
                small
                color="primary"
              >
                refresh
              </v-icon>
              {{
                props.item.repeatInfo.freq !== null && props.item.repeatInfo.freq !== undefined
                  ? (props.item.repeatInfo.freq === 'WEEKLY'
                    ? ('Weekly' + (props.item.repeatInfo.byInterval ? '(' + props.item.repeatInfo.byInterval + ')' : '' ) )
                    : 'Daily' )
                  : '-'
              }}
            </td>
            <td class="text-center">
              <v-icon
                v-if="props.item.repeatInfo.freq !== null && props.item.repeatInfo.freq !== undefined"
                small
                color="primary"
              >
                refresh
              </v-icon>
              {{ props.item.repeatInfo.freq !== null && props.item.repeatInfo.freq !== undefined ? props.item.repeatInfo.freq : '-' }}
            </td>
          </template> -->
          <template v-slot:item.startDtime="{ item }">
            {{ item.startDtime | formatDate }}
          </template>
          <template v-slot:item.endDtime="{ item }">
            {{ item.endDtime | formatDate }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-sheet
              dark
              label
              small
              :color="getColorByStatus(item.status)"
              text-color="white"
              style="height: 25px; padding-top: 2px;"
            >
              {{
                item.status === 'r'
                  ? '예약'
                  : item.status === 's'
                    ? '진행중'
                    : item.status === 'q'
                      ? '승인 대기'
                      : '종료'
              }}
            </v-sheet>
          </template>
          <template v-slot:item.detail="{ item }">
            <v-btn
              icon
              @click="detailMeeting(item)"
            >
              <v-icon
                color="info"
              >
                mdi-information
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              color="green"
              :disabled="item.status !== 'r' || item.creator.email !== info.email"
              @click="editMeeting(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              color="error"
              :disabled="item.creator.email !== info.email"
              @click="cancelMeeting(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>

        <!-- mobile view -->
        <v-timeline
          v-else
          dense
        >
          <v-slide-x-reverse-transition
            v-if="todayMeetings.length > 0"
            group
            hide-on-leave
          >
            <v-timeline-item
              v-for="item in todayMeetings"
              :key="item._id"
              :color="getColorByStatus(item.status)"
              small
              fill-dot
            >
              <v-card
                :color="getColorByStatus(item.status)"
                dark
              >
                <v-card-title class="title">
                  {{ item.statusText }} - {{ item.title }}
                </v-card-title>
                <v-card-text class="white black--text pa-4">
                  <p>시작 : {{ item.startDtime | formatDate }}</p>
                  <p>종료 : {{ item.endDtime | formatDate }}</p>
                  <p>예약자 : {{ item.creator.username }}</p>
                  <p>회의실 : {{ item.roomIds[0].name }}</p>
                  <v-btn
                    color="orange"
                    class="mr-2"
                    outlined
                    :fab="$vuetify.breakpoint.smAndDown"
                    :small="$vuetify.breakpoint.smAndDown"
                    @click="editMeeting(item)"
                  >
                    <v-icon>
                      mdi-pencil-outline
                    </v-icon>
                    {{ $vuetify.breakpoint.smAndDown ? '' : '수정' }}
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-2"
                    outlined
                    :fab="$vuetify.breakpoint.smAndDown"
                    :small="$vuetify.breakpoint.smAndDown"
                    @click="cancelMeeting(item)"
                  >
                    <v-icon>
                      mdi-trash-can-outline
                    </v-icon>
                    {{ $vuetify.breakpoint.smAndDown ? '' : '취소' }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-slide-x-reverse-transition>
          <v-alert
            v-else
            border="right"
            colored-border
            type="error"
            elevation="2"
          >
            금일 예정된 회의가 없습니다.
          </v-alert>
        </v-timeline>
      </v-card-text>
    </material-card>
    <v-btn
      v-if="$vuetify.breakpoint.mdAndUp"
      depressed
      absolute
      bottom
      right
      dark
      large
      class="primary v-btn--example mb-5 mr-2"
      @click="$router.push('/reservation/')"
    >
      <v-icon>
        mdi-plus
      </v-icon>
      {{ $t('meeting.reserve') }}
    </v-btn>
    <v-btn
      v-else
      fab
      large
      dark
      absolute
      bottom
      right
      color="primary"
      class="v-btn--example mb-15"
      @click="$router.push('/reservation/')"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <confirm-dialog
      :title="confirm.title"
      :content="confirm.content"
      :dialog="confirm.dialog"
      :to-parent="confirmDialogClose"
    />

    <custom-dialog
      :title="infoDialog.title"
      :dialog="infoDialog.dialog"
      :to-parent="infoDialogClose"
      :is-confirm="true"
    >
      <div slot="content">
        <v-row
          v-if="selectedMeeting !== null"
          justify="center"
          align="center"
        >
          <v-col cols="12">
            <v-text-field
              :value="selectedMeeting.title"
              readonly
              dense
              hide-details
              label="회의제목"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedMeeting.startDtime | formatDate"
              readonly
              dense
              hide-details
              label="시작시간"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedMeeting.endDtime | formatDate"
              readonly
              dense
              hide-details
              label="종료시간"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedMeeting.roomIds[0].buildingName"
              readonly
              dense
              hide-details
              label="건물"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedMeeting.roomIds[0].typeName"
              readonly
              dense
              hide-details
              label="유형"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedMeeting.roomIds[0].name"
              readonly
              dense
              hide-details
              label="회의실"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              :value="selectedMeeting.creator.username ||
                selectedMeeting.creator.displayName"
              readonly
              dense
              hide-details
              label="예약자"
            />
          </v-col>
        </v-row>
      </div>
    </custom-dialog>
  </v-container>
</template>
<script>
  import { get } from 'vuex-pathify'
  import * as helpers from '@/util/helpers'
  import moment from 'moment'

  export default {

    data: () => ({
      heading: '',
      meetings: [],
      todayMeetings: [],
      loading: false,
      options: {
        sortDesc: true,
        page: 1,
        itemsPerPage: 10,
      },
      confirm: {
        title: '',
        content: '',
        dialog: false,
      },
      infoDialog: {
        title: '',
        content: '',
        dialog: false,
      },
      selectedMeeting: null,
      interval: null,
    }),

    computed: {
      info: get('user/info'),
    },

    created () {
      this.heading = this.$t('page.meeting-list')
      this.getMeetings()
      // this.getHanDokMeetings()
    },

    mounted () {
      this.interval = setInterval(() => {
        const sec = moment().seconds()
        if (sec === 10) {
          this.getMeetings()
          // this.getHanDokMeetings()
        }
      }, 1000)
    },

    beforeDestroy () {
      clearInterval(this.interval)
      this.interval = null
    },

    methods: {
      getHeaders () {
        return [
          { text: this.$t('meeting.sta-time'), value: 'startDtime', width: '150px !important', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.end-time'), value: 'endDtime', width: '150px !important', align: 'center', sortable: false, class: 'primary--text' },
          // { text: this.$t('meeting.type'), value: 'isImmediately', width: '30px !important', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.type'), value: 'roomIds[0].typeName', width: '120px !important', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.meeting-room'), value: 'roomIds[0].name', width: '200px !important', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.creator'), value: 'creator.username', width: '100px !important', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.title'), value: 'title', width: '200px', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.status'), value: 'status', width: '100px', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.detail'), value: 'detail', align: 'center', width: '100px', sortable: false, class: 'primary--text' },
          // { text: this.$t('meeting.repeat'), align: 'center', width: '110px', sortable: false, class: 'primary--text' },
          // { text: this.$t('meeting.control'), align: 'center', width: '70px', sortable: false, class: 'primary--text' },
          { text: '수정 / 삭제', value: 'actions', style: 'color: black;', align: 'center', width: '120px', sortable: false, class: 'primary--text' },
          // { text: this.$t('meeting.skype'), style: 'color: black;', align: 'center', width: '80px', sortable: false, class: 'primary--text' }

          // { text: this.$t('meeting.meeting-name'), value: 'title', align: 'center', sortable: false },
          // { text: this.$t('meeting.meeting-sta-time'), value: 'startDtime', align: 'center', sortable: false, },
          // { text: this.$t('meeting.meeting-end-time'), value: 'endDtime', align: 'center', sortable: false },
          // { text: this.$t('meeting.creator'), value: 'creator', align: 'center', sortable: false },
          // { text: this.$t('meeting.meeting-type'), value: 'type', align: 'center', sortable: false },
          // { text: this.$t('meeting.repeat'), value: 'repeat', align: 'center', sortable: false },
          // { text: this.$t('meeting.status'), value: 'status', align: 'center', sortable: false },
          // { text: this.$t('meeting.detail'), align: 'center', width: '50px', sortable: false },
          // { text: this.$t('meeting.delete'), align: 'center', width: '125px', sortable: false }
        ]
      },
      async getMeetings () {
        await this.$http.get(`/api/v1/meetings/email/${this.info.email}`).then(response => {
          // console.log('response.data :: ' + JSON.stringify(response.data))
          this.meetings = response.data
          this.todayMeetings.push(this.meetings)
        }).catch(err => {
          console.log(err)
        })
      },
      // async getHanDokMeetings () {
      //   await this.$http.get(`/api/v1/meetings/getHandokMeeting/email/${this.info.email}`).then(response => {
      //     // console.log('response.data :: ' + JSON.stringify(response.data))
      //     this.meetings = response.data
      //     this.todayMeetings.push(this.meetings)
      //     console.log(this.todayMeetings)
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // },
      detailMeeting (meeting) {
        this.selectedMeeting = meeting
        this.infoDialog.title = '회의정보'
        this.infoDialog.dialog = true
      },
      async editMeeting (meeting) {
        this.$router.push({ path: '/reservation/', query: { meetingId: meeting._id } })
      },
      async cancelMeeting (meeting) {
        this.selectedMeeting = meeting
        this.confirm.dialog = true
        this.confirm.title = '회의 취소'
        this.confirm.content = '회의를 취소하시겠습니까?'
      },
      getColorByStatus (status) {
        return helpers.getColorByStatus(status)
      },
      async confirmDialogClose (result) {
        if (result === 'ok') {
          // 삭제
          await this.$http.delete(`/api/v1/meetings/${this.selectedMeeting._id}`).then(async () => {
            await this.getMeetings()
          }).catch(error => {
            console.log(error)
          })
        }
        this.confirm.dialog = false
      },
      infoDialogClose () {
        this.infoDialog.dialog = false
      },
    },
  }
</script>

<style scoped>

</style>
